import AcceptIcon from '@/shared/assets/icons/acceptDeal.svg?react'
import { BaseDialog } from '@/shared/components'

type Props = {
  isModalOpen: boolean
  onConfirm: () => void
}

export const AcceptedOrder = ({ isModalOpen, onConfirm }: Props) => {
  return (
    <BaseDialog
      isVisible={isModalOpen}
      onClose={onConfirm}
      onStepBack={onConfirm}
      closeButtonName="Вернуться назад"
      xButton={false}
      iconTitle={<AcceptIcon className="mx-auto text-[var(--status-purple-fill)]" />}
    >
      <p className="text-[20px] text-center mt-[-8px]">Спор принят</p>
    </BaseDialog>
  )
}
